// A record as `/api/crud` takes it (platform D143): every field of the entity, nothing else, each as
// `crudInputSchema` accepts it. A text field is never null — the platform refuses a null text with a
// 400 ("<label> must be text"), and the database answers NULL for a column nobody wrote — so empty
// is ""; a number or date may be null. Every write goes through it (`writer.ts`, `logged-write.ts`), so
// a nullable column added later saves as the others do.

import type { CrudEntity } from "@axny/platform-contracts";
import { asDay } from "./days";

export function crudInput(entity: CrudEntity, record: Record<string, unknown>): Record<string, unknown> {
  const out: Record<string, unknown> = {};
  for (const f of entity.fields) {
    const v = record[f.name];
    if (f.kind === "text" || f.kind === "longText") out[f.name] = v === null || v === undefined ? "" : String(v);
    else if (f.kind === "date") out[f.name] = asDay(v);
    else if (f.kind === "number" || f.kind === "currency")
      out[f.name] = v === null || v === undefined || v === "" ? null : Number(v);
    else out[f.name] = v === "" || v === undefined ? null : v;
  }
  return out;
}
